import { useSetRecoilState } from 'recoil'
import snackbarState from '../stores/atoms/snackbarAtom'

export default function useSnackbar() {
    const setSnackbar = useSetRecoilState(snackbarState)

    const openSnackbar = (message: string) => {
        setSnackbar({
            message,
            opened: true
        })

        setTimeout(() => {
            setSnackbar({
                message: '',
                opened: false
            })
        }, 3000)
    }

    return { openSnackbar }
}
